"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = tslib_1.__importDefault(require("react"));
const react_if_1 = require("react-if");
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const utils_1 = require("../utils");
const OsmosysTooltip_1 = require("./OsmosysTooltip");
exports.OsmosysToast = ({ isOpen, title, children, icon, iconPreset, tooltip, color, onToggle, uncontrolledDismissal, }) => {
    const [dismissed, toggleDismissable] = react_use_1.useToggle(false);
    const closed = uncontrolledDismissal ? !dismissed : isOpen === false;
    const open = !closed;
    let t = (react_1.default.createElement(reactstrap_1.Toast, { isOpen: open, className: "mt-2 m-2" },
        react_1.default.createElement(react_if_1.When, { condition: !!title },
            react_1.default.createElement(reactstrap_1.ToastHeader
            // color="danger"
            , { 
                // color="danger"
                toggle: uncontrolledDismissal
                    ? toggleDismissable
                    : onToggle
                        ? () => {
                            onToggle(false);
                        }
                        : undefined },
                react_1.default.createElement(react_if_1.If, { condition: !!(icon || iconPreset) },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: iconPreset === 'globe'
                            ? pro_solid_svg_icons_1.faGlobeAmericas
                            : iconPreset === 'bell'
                                ? pro_solid_svg_icons_1.faBell
                                : icon, className: utils_1.classnames('mr-1', color && `text-${color}`) })),
                title)),
        react_1.default.createElement(react_if_1.When, { condition: !!children },
            react_1.default.createElement(reactstrap_1.ToastBody, { className: "bg-white" }, children))));
    if (open && tooltip) {
        t = react_1.default.createElement(OsmosysTooltip_1.OsmosysTooltip, { label: tooltip }, t);
    }
    return react_1.default.createElement(utils_1.Portal, { elementID: "osmosys-toasts" }, t);
};
//# sourceMappingURL=OsmosysToast.js.map